/* ---------- Sort dropdown ---------- */
(function () {
  var wrappers = document.querySelectorAll('[data-sort-wrapper]');
  wrappers.forEach(function (wrapper) {
    var toggle = wrapper.querySelector('[data-sort-toggle]');
    var menu = wrapper.querySelector('.collection__sort-menu');
    var options = wrapper.querySelectorAll('[data-sort-value]');
    if (!toggle || !menu) return;

    function openMenu() {
      menu.hidden = false;
      wrapper.setAttribute('data-sort-open', '');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      menu.hidden = true;
      wrapper.removeAttribute('data-sort-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) openMenu(); else closeMenu();
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var value = opt.dataset.sortValue;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        url.searchParams.delete('page');
        window.location.href = url.pathname + url.search;
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target) && !menu.hidden) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) closeMenu();
    });
  });
})();

/* ---------- Filter drawer ---------- */
(function () {
  var drawer = document.querySelector('[data-filters-drawer]');
  if (!drawer) return;

  var openBtns = document.querySelectorAll('[data-filters-open]');
  var closeBtns = drawer.querySelectorAll('[data-filters-close]');
  var form = drawer.querySelector('[data-filter-form]');
  var body = drawer.querySelector('.filters-drawer__body');
  var hasHydrated = false;

  function bindCheckboxHighlight() {
    if (!form) return;
    form.querySelectorAll('[data-filter-checkbox]').forEach(function (cb) {
      if (cb.dataset.highlightBound === 'true') return;
      cb.dataset.highlightBound = 'true';
      cb.addEventListener('change', function () {
        var item = cb.closest('.filters__item');
        if (item) item.classList.toggle('is-active', cb.checked);
        scheduleCountRefresh();
      });
    });
    form.querySelectorAll('[data-filter-price]').forEach(function (input) {
      if (input.dataset.highlightBound === 'true') return;
      input.dataset.highlightBound = 'true';
      input.addEventListener('change', scheduleCountRefresh);
    });
  }

  /** Build the URL the SHOW RESULTS button would submit, given current form state. */
  function buildTentativeUrl() {
    if (!form) return window.location.pathname;
    var params = [];
    form.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (cb) {
      params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
    });
    form.querySelectorAll('[data-filter-price]').forEach(function (input) {
      if (input.value) {
        params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
      }
    });
    var url = new URL(window.location.href);
    var sortBy = url.searchParams.get('sort_by');
    if (sortBy) params.push('sort_by=' + encodeURIComponent(sortBy));
    return window.location.pathname + (params.length ? '?' + params.join('&') : '');
  }

  /**
   * Debounced fetch that previews the counts the user would see AFTER applying
   * their current tentative selection — no page reload required.
   */
  var refreshTimer = null;
  function scheduleCountRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCounts, 200);
  }

  function refreshCounts() {
    if (!body) return;
    var target = buildTentativeUrl();

    fetch(target, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.filters-drawer__body');
        if (!fresh) return;

        // Build a lookup: name=value -> count (from the tentative response)
        var freshCounts = {};
        fresh.querySelectorAll('[data-filter-checkbox]').forEach(function (cb) {
          var item = cb.closest('.filters__item');
          var countEl = item && item.querySelector('.filters__count');
          freshCounts[cb.name + '=' + cb.value] = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
        });

        // Update each item in the current drawer
        body.querySelectorAll('.filters__item').forEach(function (item) {
          var cb = item.querySelector('[data-filter-checkbox]');
          if (!cb) return;
          var key = cb.name + '=' + cb.value;
          var newCount = freshCounts[key];
          var countEl = item.querySelector('.filters__count');
          if (newCount === undefined) newCount = 0;

          if (countEl) {
            countEl.textContent = newCount;
          } else if (newCount > 0) {
            var span = document.createElement('span');
            span.className = 'filters__count';
            span.textContent = newCount;
            var label = item.querySelector('.filters__checkbox');
            if (label) label.appendChild(span);
          }

          // Disable rows that would yield 0 results — unless the user has just
          // checked them (in which case keep their selection interactive).
          if (newCount === 0 && !cb.checked) {
            cb.disabled = true;
            cb.setAttribute('disabled', 'disabled');
            item.classList.add('is-disabled');
          } else {
            cb.disabled = false;
            cb.removeAttribute('disabled');
            item.classList.remove('is-disabled');
          }
        });

        // Update the toolbar "FILTERS · (N)" indicator
        var total = body.querySelectorAll('[data-filter-checkbox]:checked').length;
        body.querySelectorAll('[data-filter-price]').forEach(function (input) {
          if (input.value) total += 1;
        });
        updateToolbarBadge(total);
      })
      .catch(function () { /* silent */ });
  }

  function updateToolbarBadge(count) {
    document.querySelectorAll('[data-filters-open]').forEach(function (btn) {
      var dot = btn.querySelector('.collection__filters-dot');
      var countEl = btn.querySelector('.collection__filters-count');
      if (count > 0) {
        if (!dot) {
          dot = document.createElement('span');
          dot.className = 'collection__filters-dot';
          dot.setAttribute('aria-hidden', 'true');
          btn.appendChild(dot);
        }
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'collection__filters-count';
          btn.appendChild(countEl);
        }
        countEl.textContent = '(' + count + ')';
      } else {
        if (dot) dot.remove();
        if (countEl) countEl.remove();
      }
    });
  }

  function open() {
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('filters-open');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (!hasHydrated) { hasHydrated = true; hydrateFullValueList(); }
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 300);
  }

  /**
   * Shopify's collection.filters is scoped to the current URL filter state —
   * values with 0 matches in the filtered subset are removed entirely. We
   * want the merchant's full value list so users see all options with counts
   * updating to reflect their current selection. Fetch the same collection
   * URL with no filter params, parse its drawer body, and merge:
   *   - keep every value from the unfiltered body (complete list)
   *   - copy count + active state from the current body for values that exist
   *   - mark values that only exist in the unfiltered body as 0/disabled
   */
  function hydrateFullValueList() {
    if (!body) return;
    var current = new URL(window.location.href);
    var hasFilter = false;
    current.searchParams.forEach(function (_, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    if (!hasFilter) return;

    var target = new URL(window.location.pathname, window.location.origin);
    var sortBy = current.searchParams.get('sort_by');
    if (sortBy) target.searchParams.set('sort_by', sortBy);

    fetch(target.href, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.filters-drawer__body');
        if (!fresh) return;

        var currentState = {};
        body.querySelectorAll('[data-filter-checkbox]').forEach(function (cb) {
          var key = cb.name + '=' + cb.value;
          var item = cb.closest('.filters__item');
          var countEl = item && item.querySelector('.filters__count');
          currentState[key] = {
            count: countEl ? parseInt(countEl.textContent, 10) || 0 : 0,
            active: cb.checked
          };
        });

        fresh.querySelectorAll('.filters__item').forEach(function (item) {
          var cb = item.querySelector('[data-filter-checkbox]');
          if (!cb) return;
          var state = currentState[cb.name + '=' + cb.value];
          var countEl = item.querySelector('.filters__count');

          if (state) {
            if (countEl) countEl.textContent = state.count;
            if (state.active) {
              // Set both property AND attribute so the state survives an
              // innerHTML serialization round-trip (only attributes serialize).
              cb.checked = true;
              cb.setAttribute('checked', 'checked');
              item.classList.add('is-active');
            } else {
              cb.checked = false;
              cb.removeAttribute('checked');
            }
          } else {
            if (countEl) {
              countEl.textContent = '0';
            } else {
              var span = document.createElement('span');
              span.className = 'filters__count';
              span.textContent = '0';
              var label = item.querySelector('.filters__checkbox');
              if (label) label.appendChild(span);
            }
            cb.disabled = true;
            cb.setAttribute('disabled', 'disabled');
            item.classList.add('is-disabled');
          }
        });

        // Preserve typed-in price values (serialize via attribute, not property).
        body.querySelectorAll('[data-filter-price]').forEach(function (input) {
          if (!input.value) return;
          var match = fresh.querySelector('[data-filter-price][name="' + input.name + '"]');
          if (match) match.setAttribute('value', input.value);
        });

        // Use replaceChildren with moved nodes instead of innerHTML so property
        // state is preserved on live nodes too (defensive).
        while (body.firstChild) body.removeChild(body.firstChild);
        while (fresh.firstChild) body.appendChild(fresh.firstChild);
        bindCheckboxHighlight();
      })
      .catch(function () { /* silent */ });
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = [];
      form.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (cb) {
        params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
      });
      form.querySelectorAll('[data-filter-price]').forEach(function (input) {
        if (input.value) {
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        }
      });
      var url = new URL(window.location.href);
      var sortBy = url.searchParams.get('sort_by');
      if (sortBy) params.push('sort_by=' + encodeURIComponent(sortBy));
      window.location.href = window.location.pathname + (params.length ? '?' + params.join('&') : '');
    });

    bindCheckboxHighlight();
  }
})();
